import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-solid-alt",
  "use": "check-solid-alt-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"check-solid-alt\"><circle cx=\"11\" cy=\"11\" r=\"11\" /><path stroke=\"#FFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M16 8l-6.875 6.875L6 11.75\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol